// 不在左侧菜单中，但是在Main组件的子页面中显示的路由定义在这个文件中

import Main from '../../manager/manager_index.vue'

// 修改密码
// const updatePassword = {
//   name: 'updatePassword',
//   path: 'updatePassword',
//   title: '修改密码',
//   component: (resolve) => require(['../components/update_password.vue'], resolve)
// }

// 定义的路由需要添加到这个数组中
const childrenRouter = [
  // homeIndex
]

const customMainRouter = {
  path: '/',
  name: 'customMainRouter',
  redirect: '/home',
  component: Main,
  children: [
    ...childrenRouter
  ]
}

export default customMainRouter



// WEBPACK FOOTER //
// ./src/custom/router/custom-main-routers.js